module.exports = __webpack_public_path__ + "media/images/emblems/Erlen-Blazono-df0dec31eafafb829f5da1c41a52bf23.png";